import { Navigate, Route } from "react-router-dom";
import Explore from "@/v2/features/explore/Explore";
import { ExploreViews } from "@/routes/explore/ExploreViews";
import { ExploreViewForm } from "@/routes/explore/ExploreViewForm";
import { ExploreViewBySlug } from "@/routes/explore/ExploreViewBySlug";
import { exploreUris } from "./exploreUris";

export const exploreRoutes = (
  <>
    <Route path={exploreUris.root}>
      <Route path={exploreUris.tickets} element={<Explore />} />
      <Route
        path={exploreUris.conversations}
        element={<Explore source="conversations" />}
      />
      <Route path={exploreUris.views} element={<ExploreViews />} />
      <Route path={exploreUris.newView} element={<ExploreViewForm />} />
      <Route path={exploreUris.editView} element={<ExploreViewForm />} />
      <Route path={exploreUris.view} element={<ExploreViewBySlug />} />

      <Route path="*" element={<Navigate to={exploreUris.tickets} />} />
      <Route index element={<Navigate to={exploreUris.tickets} replace />} />
    </Route>
  </>
);
